import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import styled, { injectGlobal } from 'react-emotion';
import GatsbyConfig from '../../gatsby-config';

import Header from '../components/header';
import { backgroundColor, fontFamilyStack, mqRuleAboveMobile, linkColor, textColor } from '../styles';

import '../fonts/fonts';
import './index.css';

injectGlobal`
  html, body {
    background: ${backgroundColor};
  }
`;

const Wrapper = styled.div`
  color: ${textColor};
  background: ${backgroundColor};
  font-family: ${fontFamilyStack};
`;
const BodyWrapper = styled.div`
  padding: 40px 0 0;
  font-family: ${fontFamilyStack};
  font-size: 22px;
  font-weight: 200;

  @media ${mqRuleAboveMobile} {
    padding: 120px 0 40px;
  }
`;
const Footer = styled.footer`
  margin: 0;
  padding: 24px;
  text-align: center;
`;
const FooterHeader = styled.h4`
  margin: 0;
  padding: 0;
  font-size: 24px;
  font-weight: 600;
`;
const FooterLink = styled.a`
  color: ${linkColor};
  text-decoration: underline;
`;

const TemplateWrapper = ({ children }) => (
  <Wrapper>
    <Helmet
      title={GatsbyConfig.siteMetadata.title}
      meta={[
        {
          name: 'description',
          content: 'Gun nuts and gun grabbers: it’s time you both come to the table and talk this out.',
        },
        {
          name: 'keywords',
          content: 'the path forward on guns, gun laws, gun control, gun rights, gun freedom, gun ban, assault weapons, second amendment, heller, gun politics, universal background checks, extreme risk protection orders, silencers, suppressors, hearing protection, national firearms act, nfa',
        },
      ]}
    />
    <Header />
    <BodyWrapper children={children()} />
    <Footer>
      <FooterHeader children='Connect' />
      On Twitter at <FooterLink href='https://twitter.com/thepathonguns' children='@thepathonguns' /><br />
      <FooterLink href='https://opensourcedefense.us18.list-manage.com/subscribe?u=e91dba353ab457f35e524041c&id=df0df6ef4a' children='Sign up for the email newsletter.' target='_blank' /> It’s good.<br />
      Email at <FooterLink href='mailto:thepathforwardonguns@gmail.com' children='thepathforwardonguns@gmail.com' />
    </Footer>
  </Wrapper>
);

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js